import React from "react";

const withProps = ({ ...parentProps }) => BaseComponent => ({ ...props }) => (
  <BaseComponent {...props} {...parentProps} />
);

export default withProps;
